import { useState } from "react";

export default function HashtagList({
  list,
  // selectedHashtag,
  // setSelectedHashtag,
  selectHashtags,
  hashtagHandler,
  firstCurrentPage
}) {
  const [update, setUpdate] = useState(false);
  return (
    <div className="hashtag-container py-2 my-2">
      <div
        className={`mx-1 my-2 p-2 d-flex align-items-center justify-content-center ${
          selectHashtags.length == 0
            ? "active-hashtag-btn"
            : "deactive-hashtag-btn"
        }`}
        onClick={() => {
          // setSelectedHashtag(-1);
          hashtagHandler("all", -1);
          firstCurrentPage();
        }}
      >
        همه
      </div>
      {list?.map(value => {
        return (
          <div
            className={`mx-1 my-2 p-2 d-flex align-items-center justify-content-center ${
              // selectedHashtag == value.id
              selectHashtags.includes(value.id)
                ? "active-hashtag-btn"
                : "deactive-hashtag-btn"
            }`}
            onClick={() => {
              hashtagHandler("other", value.id);
              // setSelectedHashtag(value.id);
              firstCurrentPage();
              setUpdate(prev => !prev);
              // console.log("**ss", selectHashtags.includes(value.id));
            }}
          >
            {value.txt}
          </div>
        );
      })}
    </div>
  );
}
